export const FuseAppStoreUrl = 'https://apps.apple.com/us/app/fuse-energy/id1618056244'
export const PlayStoreUrl = 'https://play.google.com/store/apps/details'
export const PlayStoreAppId = 'com.fuseenergy'
export const FusePlayStoreUrl = `${PlayStoreUrl}?id=${PlayStoreAppId}`

export const AppDownloadUrl = 'https://www.fuseenergy.com/app/mobile/download'

export const ContactUsInstallsEmail = 'mailto:installations@fuseenergy.com'
export const MailToSupportLink = 'mailto:support@fuseenergy.com'
export const MailToProjectsLink = 'mailto:projects@fuseenergy.com'
